export default __webpack_public_path__ + "static/media/BuckeyeLeaf-Active.e45d2d19.svg";